import img from './img';
import audio from './audio';
import dataConfig from './gameData.config.js';

var config = {
  engine: 'stepByStep',
  gameConfig: dataConfig,
  hideControlPanel: true,
  title: [
    {
      text: `Uruchom edytor grafiki Paint.`,
      audio: 'games/page011_game4/audio/polecenie.mp3',
      ////audio: 'test.mp3',
      // pos: {
      //     x: 10,
      //     y: 10
      // }
    },
  ],
  assets: {
    img: img || [],
    audio: audio || [],
    extendetJS: [],
    extendetStyle: [],
  },
};

// console.log( 'config', config );
export default config;
